import React from "react";
import { Link } from "react-router-dom";
import {
  FiHome,
  FiVideo,
  FiUser,
  FiBell,
  FiHeart,
  FiBookOpen,
  FiPhoneCall,
  FiMail,
  FiInstagram,
  FiFacebook,
  FiTwitter,
  FiYoutube,
} from "react-icons/fi";
import logo from "../assets/img/logo.png";
import googlePlay from "../assets/img/googleplay.png";
import appStore from "../assets/img/appstore.png"; 



function Footer() {

  const [showAppModal, setShowAppModal] = React.useState(false);


  return (

    <>
    <footer className="footer">
      {/* 🌟 Top Section */}
      <div className="footer-top container">
        <div className="row g-2 text-start">
          {/* Column 1: Brand Info */}
          <div className="  col-md-3 ">
            <Link to="/" className="navbar-brand d-flex align-items-center gap-2 text-center">
  {/* <span className="logo-text">soulsathi</span> */}
</Link>
            <p>
              Find your perfect life partner through our trusted and
              secure matchmaking platform. Where love meets destiny.
            </p>

            <div className="social-icons">
              <a href="https://www.facebook.com/people/Soulsathicom/61584589261461/" target="_blank" rel="noreferrer">
                <FiFacebook />
              </a>
              <a href="#" target="_blank" rel="noreferrer">
                <FiTwitter />
              </a>
              <a href="https://www.instagram.com/soulsathi_official/" target="_blank" rel="noreferrer">
                <FiInstagram />
              </a>
              <a href="#" target="_blank" rel="noreferrer">
                <FiYoutube />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className=" col-md-3  col-6">
            <h5>Quick Links</h5>
            <ul>
              <li>
                <Link to="/"><FiHome className="me-2" /> Home</Link>
              </li>
              {/* <li>
                <Link to="/videos"><FiVideo className="me-2" /> Videos</Link>
              </li> */}
              <li>
                <Link to="/my-profile"><FiUser className="me-2" /> My Profile</Link>
              </li>
              {/* <li>
                <Link to="/notifications"><FiBell className="me-2" /> Notifications</Link>
              </li> */}
              <li>
                <Link to="/about"><FiBookOpen className="me-2" /> About Us</Link>
              </li>
              <li>
                <Link to="/contact"><FiPhoneCall className="me-2" /> Contact</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Support & Legal */}
          <div className=" col-md-3  col-6">
            <h5>Support</h5>
            <ul>
              <li>
                <Link to="/terms-conditions"  rel="noreferrer">
                  <FiHeart className="me-2" /> Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" rel="noreferrer">
                  <FiHeart className="me-2" /> Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/faq"><FiBookOpen className="me-2" /> FAQs</Link>
              </li>
              <li>
                <Link to="/help"><FiMail className="me-2" /> Help Center</Link>
              </li>
            </ul>
          </div>

          {/* Column 4: App Download */}
          <div className=" col-md-3 col-12">
            <h5>Get Our App</h5>
            <p>Experience Soulsathi on the go — find your match anywhere!</p>
            <div className="store-buttons">
  <div
    className="store-btn"
    onClick={() => setShowAppModal(true)}
  >
    <img src={googlePlay} alt="Get it on Google Play" />
  </div>

  <div
    className="store-btn"
    onClick={() => setShowAppModal(true)}
  >
    <img src={appStore} alt="Download on the App Store" />
  </div>
</div>

            <p className="trademark-text mt-2">
          Apple and the Apple Logo are trademarks of Apple Inc. <br />
          Google Play and the Google Play logo are trademarks of Google LLC.
        </p>
          </div>
        </div>
      </div>

      {/* 🌙 Bottom Section */}
      <div className="footer-bottom text-center">
        <p className="text-white p-0 m-0">
          © {new Date().getFullYear()} <strong>Soulsathi.com</strong> — All rights reserved.  
          Designed & Developed by{" "}
          <a href="https://ignsoftwares.in/" target="_blank" rel="dofollow" className="text-white">
            IGN SOFTWARES
          </a>
        </p>

        
      </div>
    </footer>


{showAppModal && (
  <>
    <div
      className="confirm-modal-backdrop"
      onClick={() => setShowAppModal(false)}
    ></div>

    <div className="confirm-modal-box">
      <div className="confirm-title">Coming Soon 🚀</div>

      <div className="confirm-text text-center">
        <strong>Android</strong> and <strong>iOS</strong> apps launching soon!  
        <br />
        Thank you for your patience ❤️
      </div>

      <div className="confirm-actions">
        <button
          className="confirm-btn confirm-yes"
          onClick={() => setShowAppModal(false)}
        >
          OK
        </button>
      </div>
    </div>
  </>
)}


</>

  );
}

export default Footer;
